import { render, staticRenderFns } from "./StatementMoreShop.vue?vue&type=template&id=0508a059&scoped=true&"
import script from "./StatementMoreShop.vue?vue&type=script&lang=js&"
export * from "./StatementMoreShop.vue?vue&type=script&lang=js&"
import style0 from "./StatementMoreShop.vue?vue&type=style&index=0&id=0508a059&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0508a059",
  null
  
)

export default component.exports